import { useState } from 'react'
import { useForm } from 'react-hook-form'
import SharedLinkEmails from './shared_link_emails'
import Tooltip from '../tooltip'

const SharedLinkEmailForm = ({ link, uuid, getLinks, setVisibleEmailsForm, scope_type, scope_id, settingsMode }) => {
  const [error, setError] = useState()

  let defaultValues = {
    sender_name: window.appData.user_name,
    sender_email: window.appData.user_email,
    subject: I18n.t('shared-link-mailer-subject', { object_name: link.sharable_name }),
    body: I18n.t('shared-link-mailer-message', { object_name: link.sharable_name, url: link.share_url })
  }
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({ reValidateMode: 'onSubmit', defaultValues: defaultValues })

  const sendEmail = (formData) => {
    jQuery.ajax({
      url: window.appData.api_path + '/shared_links/' + link.id + '/send_email',
      method: 'POST',
      data: {
        email: formData,
        scope_type: scope_type,
        scope_id: scope_id
      },
      beforeSend: () => {
        setError(null)
      },
      success: () => {
        reset()
        setVisibleEmailsForm(false)
        getLinks()
      },
      error: (data) => {
        if (data.responseJSON?.errors) {
          setError(data.responseJSON.errors.join('. '))
        }
      }
    })
  }

  return (
    <>
      {!settingsMode ? (
        <form onSubmit={handleSubmit(sendEmail)} className="react-form mb-16">
          <div className={`form-group ${errors.recipients ? 'has-error' : ''}`}>
            <label htmlFor={`recipients-${uuid}`}>
              <span className="mr-8">{I18n.t('activerecord.attributes.shared_link.recipients')}</span>
              <Tooltip content={I18n.t('periodic-export-recipient-hint')} placement="bottom">
                <i className="fa fa-question-circle"></i>
              </Tooltip>
            </label>
            <input
              name="recipients"
              id={`recipients-${uuid}`}
              {...register('recipients', {
                required: true,
                maxLength: { value: 200 },
                pattern: window.groupEmailPattern
              })}
              type="text"
              className="input form-control"
              autoFocus={true}
              autoComplete="off"
            />
            {errors.recipients?.type === 'required' && (
              <span className="help-block">{I18n.t('simple_form.required.text')}</span>
            )}
            {errors.recipients?.type === 'maxLength' && (
              <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 200 })}</span>
            )}
            {errors.recipients?.type === 'pattern' && (
              <span className="help-block">{I18n.t('periodic-export-email-pattern')}</span>
            )}
          </div>

          {error ? (
            <p>
              <strong className="text-danger">{error}</strong>
            </p>
          ) : null}

          <div className="row">
            <div className="col-md-6">
              <div className={`form-group ${errors.sender_name ? 'has-error' : ''}`}>
                <label htmlFor={`sender_name-${uuid}`}>
                  {I18n.t('activerecord.attributes.shared_link.sender_name')}
                </label>
                <input
                  name="sender_name"
                  id={`sender_name-${uuid}`}
                  {...register('sender_name', { required: true, maxLength: { value: 50 } })}
                  type="text"
                  className="input form-control"
                  autoComplete="off"
                />
                {errors.sender_name?.type === 'required' && (
                  <span className="help-block">{I18n.t('simple_form.required.text')}</span>
                )}
                {errors.sender_name?.type === 'maxLength' && (
                  <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 50 })}</span>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className={`form-group ${errors.sender_email ? 'has-error' : ''}`}>
                <label htmlFor={`sender_email-${uuid}`}>
                  {I18n.t('activerecord.attributes.shared_link.sender_email')}
                </label>
                <input
                  name="sender_email"
                  id={`sender_email-${uuid}`}
                  {...register('sender_email', {
                    required: true,
                    maxLength: { value: 50 },
                    pattern: window.emailPattern
                  })}
                  type="text"
                  className="input form-control"
                  autoComplete="off"
                />
                {errors.sender_email?.type === 'required' && (
                  <span className="help-block">{I18n.t('simple_form.required.text')}</span>
                )}
                {errors.sender_email?.type === 'maxLength' && (
                  <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 50 })}</span>
                )}
                {errors.sender_email?.type === 'pattern' && (
                  <span className="help-block">{I18n.t('periodic-export-email-pattern')}</span>
                )}
              </div>
            </div>
          </div>

          <div className={`form-group ${errors.subject ? 'has-error' : ''}`}>
            <label htmlFor={`subject-${uuid}`}>{I18n.t('activerecord.attributes.shared_link.subject')}</label>
            <input
              name="subject"
              id={`subject-${uuid}`}
              {...register('subject', { required: true, maxLength: { value: 80 } })}
              type="text"
              className="input form-control"
              autoComplete="off"
            />
            {errors.subject?.type === 'required' && (
              <span className="help-block">{I18n.t('simple_form.required.text')}</span>
            )}
            {errors.subject?.type === 'maxLength' && (
              <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 80 })}</span>
            )}
          </div>

          <div className={`form-group ${errors.body ? 'has-error' : ''}`}>
            <label htmlFor={`body-${uuid}`}>{I18n.t('activerecord.attributes.shared_link.body')}</label>
            <textarea
              name="body"
              id={`body-${uuid}`}
              rows="5"
              {...register('body', { required: true, maxLength: { value: 1000 } })}
              type="text"
              className="textarea form-control"
              autoComplete="off"
            />
            {errors.body?.type === 'required' && (
              <span className="help-block">{I18n.t('simple_form.required.text')}</span>
            )}
            {errors.body?.type === 'maxLength' && (
              <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 1000 })}</span>
            )}
          </div>

          <button type="submit" className="btn btn-primary btn-lg align-top">
            {I18n.t('send')}
          </button>
        </form>
      ) : null}
      <SharedLinkEmails emails={link.emails} />
    </>
  )
}

export default SharedLinkEmailForm
